import { useMatch } from "react-router";
import isEmpty from "lodash/isEmpty";
import { Path } from "utils/constants/paths.constants";

const useGlobalNavigation = () => {
  const pathMatches = [
    Path.ProjectECTD,
    Path.ProjectDocument,
    Path.ProjectStructuredDocument,
  ]
    .map(useMatch)
    .filter((pathMatch) => pathMatch);

  return {
    isGlobalNavigationVisible: isEmpty(pathMatches),
  };
};

export default useGlobalNavigation;
